import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import { isError } from 'lodash';

export const NotificationsContext = createContext();

export const NotificationsConsumer = NotificationsContext.Consumer;

const initialState = {
  isSuccess: false,
  isError: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'FAILED_SAVE_APPLICATION':
      return {
        ...state,
        isError: true,
        isSuccess: false,
      };
    case 'FAILED_SUBMIT_APPLICATION':
      return {
        ...state,
        isError: true,
        isSuccess: false,
      };
    case 'SAVE_APPLICATION_SUCCESS':
      return {
        ...state,
        isSuccess: true,
        isError: false,
      };
    case 'REMOVE_NOTIFICATION': {
      return {
        ...state,
        isSuccess: false,
        isError: false,
      };
    }
    default:
      throw new Error();
  }
};

export const NotificationsContextProvider = props => {
  const [notificationState, dispatchNotification] = useReducer(reducer, initialState);

  return (
    <NotificationsContext.Provider value={[notificationState, dispatchNotification]}>
      {props.children}
    </NotificationsContext.Provider>
  );
};

NotificationsContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};
